import { g as O, c as x, _ as m, a as D, p as e } from "./createTheme-02ce03eb.js";
import * as h from "react";
import { j as P, c as C } from "./useTheme-efe1290c.js";
import { s as M } from "./styled-38387a7e.js";
import { g as S, u as U, c as w } from "./useThemeProps-ee4acb93.js";
import { f as W } from "./formControlState-9148c46f.js";
import { u as k } from "./useFormControl-c75d3f58.js";
import { T as L } from "./Typography-4117263d.js";
import { r as q } from "./refType-e39501b1.js";
function z(l) {
  return O("MuiFormControlLabel", l);
}
const A = S("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error"]), c = A, B = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "slotProps", "value"], H = (l) => {
  const {
    classes: o,
    disabled: r,
    labelPlacement: n,
    error: t
  } = l, b = {
    root: ["root", r && "disabled", `labelPlacement${x(n)}`, t && "error"],
    label: ["label", r && "disabled"]
  };
  return w(b, z, o);
}, I = M("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (l, o) => {
    const {
      ownerState: r
    } = l;
    return [{
      [`& .${c.label}`]: o.label
    }, o.root, o[`labelPlacement${x(r.labelPlacement)}`]];
  }
})(({
  theme: l,
  ownerState: o
}) => m({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${c.disabled}`]: {
    cursor: "default"
  }
}, o.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, o.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, o.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${c.label}`]: {
    [`&.${c.disabled}`]: {
      color: (l.vars || l).palette.text.disabled
    }
  }
})), v = /* @__PURE__ */ h.forwardRef(function(o, r) {
  var n;
  const t = U({
    props: o,
    name: "MuiFormControlLabel"
  }), {
    className: b,
    componentsProps: T = {},
    control: i,
    disabled: F,
    disableTypography: R,
    label: j,
    labelPlacement: $ = "end",
    slotProps: N = {}
  } = t, E = D(t, B), d = k();
  let a = F;
  typeof a > "u" && typeof i.props.disabled < "u" && (a = i.props.disabled), typeof a > "u" && d && (a = d.disabled);
  const u = {
    disabled: a
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((p) => {
    typeof i.props[p] > "u" && typeof t[p] < "u" && (u[p] = t[p]);
  });
  const _ = W({
    props: t,
    muiFormControl: d,
    states: ["error"]
  }), y = m({}, t, {
    disabled: a,
    labelPlacement: $,
    error: _.error
  }), g = H(y), f = (n = N.typography) != null ? n : T.typography;
  let s = j;
  return s != null && s.type !== L && !R && (s = /* @__PURE__ */ P.jsx(L, m({
    component: "span"
  }, f, {
    className: C(g.label, f == null ? void 0 : f.className),
    children: s
  }))), /* @__PURE__ */ P.jsxs(I, m({
    className: C(g.root, b),
    ownerState: y,
    ref: r
  }, E, {
    children: [/* @__PURE__ */ h.cloneElement(i, u), s]
  }));
});
process.env.NODE_ENV !== "production" && (v.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component appears selected.
   */
  checked: e.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: e.shape({
    typography: e.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: e.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: e.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: e.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: q,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: e.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: e.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: e.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: e.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: e.shape({
    typography: e.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * The value of the component.
   */
  value: e.any
});
const ee = v;
export {
  ee as F,
  c as f
};
